/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiListOrganizationDomainClaimsResponse,
  getCoinbaseEngUsersAccountManagementApiApiListOrganizationDomainClaimsResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiListOrganizationDomainClaimsResponse';

export type ListOrganizationDomainClaimsArgs = {
  /**
   * organization_id is the organization to list claimed domains for; always
validated against the caller's auth token.
   */
  organizationId?: string;
};

export type ListOrganizationDomainClaimsResult =
  CoinbaseEngUsersAccountManagementApiApiListOrganizationDomainClaimsResponse;

const validateListOrganizationDomainClaimsResult = (value: unknown) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiListOrganizationDomainClaimsResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: ListOrganizationDomainClaimsResult data does not match contract.`,
      errors,
    );
  }
};

export const getListOrganizationDomainClaimsUrl = (
  params: ListOrganizationDomainClaimsArgs,
  {
    additionalParams,
    baseUrl,
  }: {
    additionalParams?: Record<string, unknown>;
    baseUrl?: string;
  } = {},
) => {
  const searchParams = new URLSearchParams();
  if (params.organizationId !== null && params.organizationId !== undefined) {
    const val = params.organizationId;
    searchParams.append('organization_id', `${val}`);
  }

  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/organization/v1/domain-management/claims${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Fetch ListOrganizationDomainClaims
 * @Url /organization/v1/domain-management/claims
 * @Auth Required
 */

export function useGetListOrganizationDomainClaims(
  params: ListOrganizationDomainClaimsArgs,
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): ListOrganizationDomainClaimsResult | undefined;

export function useGetListOrganizationDomainClaims(
  params: ListOrganizationDomainClaimsArgs,
  options?: FetchOptions,
): ListOrganizationDomainClaimsResult;

export function useGetListOrganizationDomainClaims(
  params: ListOrganizationDomainClaimsArgs,
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getListOrganizationDomainClaimsUrl(params, options);
  const data = useFetch<ListOrganizationDomainClaimsResult>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateListOrganizationDomainClaimsResult(data);
  }

  return data;
}

/**
 * Access ListOrganizationDomainClaims fetch callback
 */
export const useGetListOrganizationDomainClaimsCallback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (
      params: ListOrganizationDomainClaimsArgs,
      additionalHeaders?: Record<string, string>,
    ) => {
      const url = getListOrganizationDomainClaimsUrl(params);
      const resource = getResource<ListOrganizationDomainClaimsResult>(
        url,
        undefined,
        additionalHeaders,
      );

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateListOrganizationDomainClaimsResult(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh ListOrganizationDomainClaims without throwing to suspense
 * @Url /organization/v1/domain-management/claims
 * @Auth Required
 */
export const useRefreshListOrganizationDomainClaims = (
  params: ListOrganizationDomainClaimsArgs,
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getListOrganizationDomainClaimsUrl(params);

  const { fetch } = useFetchableResource<ListOrganizationDomainClaimsResult>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove ListOrganizationDomainClaims from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /organization/v1/domain-management/claims
 */
export const useClearListOrganizationDomainClaims = (params: ListOrganizationDomainClaimsArgs) => {
  const url = getListOrganizationDomainClaimsUrl(params);

  const { clear } = useFetchableResource<ListOrganizationDomainClaimsResult>(url);

  return clear;
};

export const useWithOptimisticListOrganizationDomainClaimsUpdates = (
  params: ListOrganizationDomainClaimsArgs,
) => {
  const url = getListOrganizationDomainClaimsUrl(params);

  const { optimisticUpdate } = useFetchableResource<ListOrganizationDomainClaimsResult>(url);

  return optimisticUpdate;
};
